// extracted by mini-css-extract-plugin
export default {"go-back-button":"goBack_go-back-button__3mbcM"};